import {combineReducers} from 'redux';
import Common from './Common';
import Dashboard from './Dashboard';
import Blogs from './Blogs';
import Business from './Business';
import Category from './Category';
import Booking from './Booking';
import Payment from './Payment';

const reducers = () =>
  combineReducers({
    dashboard: Dashboard,
    common: Common,
    blogs: Blogs,
    business: Business,
    category: Category,
    booking: Booking,
    payment: Payment,
  });
export default reducers;
